import React from 'react';
import { useSelector } from 'react-redux';
import Fade from '@material-ui/core/Fade';
import Icons from 'consts/icons';
import ComponentSettings from 'components/user/settings/UserSettings/ComponentSettings';
import UserSettingsDetails from 'components/user/settings/UserSettings/MainSettings/UserSettingsDetails';
import DashboardConfiguration from 'components/dashboard/configuration/Main';
import { SidebarMenuDetailsUseStyles } from './SidebarMenuDetailsUseStyles';

const SidebarMenuSettingsDetails = () => {
  const [items, setItems] = React.useState([]);
  const [details, setDetails] = React.useState(null);
  const classes = SidebarMenuDetailsUseStyles();

  const toggleModal = () => {
    if (details) setDetails(null);
  };

  const useString = () => {
    const lang = useSelector(state => state.language);

    return lang;
  };
  const subtitles = useString().sidebar.settings;

  React.useEffect(() => {
    setItems([
      {
        name: 'userSettings',
        icon: <Icons.Settings.User />,
        url: <UserSettingsDetails />,
      },
      {
        name: 'dashboardSettings',
        icon: <Icons.Settings.Dashboard />,
        url: <DashboardConfiguration />,
      },
    ]);
  }, []);

  return (
    <>
      <div className={`${classes.SidebarMenuDetails}__table`}>
        {items.map(item => (
          <div
            key={item.name}
            className={`${classes.SidebarMenuDetails}__list`}
          >
            <div
              key={item.name}
              className={`${classes.SidebarMenuDetails}__list__item ${
                details === item.name ? 'active' : ''
              }`}
              onClick={
                () => setDetails(details !== item.name ? item.name : null)
                // eslint-disable-next-line react/jsx-curly-newline
              }
              aria-hidden="true"
            >
              <div
                className={`${classes.SidebarMenuDetails}__list__item__icon`}
              >
                {item.icon}
              </div>
              <span
                className={`${classes.SidebarMenuDetails}__list__item__text`}
              >
                {subtitles[`${item.name}_`]}
              </span>
            </div>
          </div>
        ))}
      </div>
      <Fade in={details !== null}>
        <div>
          <ComponentSettings
            details={details}
            setDetails={setDetails}
            items={items}
            toggleModal={toggleModal}
          />
        </div>
      </Fade>
    </>
  );
};

export default SidebarMenuSettingsDetails;
